import { createNutrimaticSdk, type NutrimaticSdk } from '@nutrimatic/sdk'

import {
  getNutrimaticApiBaseUrl,
  isNutrimaticConfigured,
  NUTRIMATIC_INFINITE_MAINNET_LEDGER,
} from '@/config/nutrimatic'

let cached: { key: string; sdk: NutrimaticSdk } | null = null

function cacheKey(apiBaseUrl: string): string {
  return `${apiBaseUrl}|${NUTRIMATIC_INFINITE_MAINNET_LEDGER.id}`
}

/**
 * Singleton SDK for the browser session (Lab / docs pattern).
 * Always configures Infinite Mainnet ledger — Nutrimatic market data is that ledger.
 * Vitrina callers use NutrimaticMarketHub / service ready — not wallet chain match.
 */
export function getNutrimaticSdk(): NutrimaticSdk | null {
  if (!isNutrimaticConfigured()) return null

  const apiBaseUrl = getNutrimaticApiBaseUrl()
  const key = cacheKey(apiBaseUrl)
  if (cached?.key === key) return cached.sdk

  const sdk = createNutrimaticSdk({
    apiBaseUrl,
    ledgers: [NUTRIMATIC_INFINITE_MAINNET_LEDGER],
    mode: 'read',
    integrationContext: 'client',
  })
  cached = { key, sdk }
  return sdk
}

export function getNutrimaticLedger() {
  return NUTRIMATIC_INFINITE_MAINNET_LEDGER
}

/** Reset cache — tests only. */
export function resetNutrimaticSdkCacheForTests(): void {
  cached = null
}
